import React from "react"

import AccountThemeEditorComponent from "./account-theme-editor-component"
import { findScenarioAccountThemeByServices } from "../../../domain/sfp/scenario-domain"
import { Profile, getProfile } from "../../../domain/sfp/user-domain"

class AccountThemeEditorContainer extends React.Component {

	state = {
		edit: false,
		submitting: false,
		confirmUncheck: false
	}

	render() {
		const scenarioTheme = this.props.themes && this.props.themes.length ? this.props.themes[this.props.col -3] : null
		const scenarioAccountTheme = scenarioTheme && this.props.row.account ? findScenarioAccountThemeByServices(this.props.scenario.themes, scenarioTheme, this.props.row.account) : null
		const comment = scenarioAccountTheme && scenarioAccountTheme.comment
		const isServiceAgent = getProfile(this.props.currentUser) === Profile.ServiceAgent

		return (
			<AccountThemeEditorComponent
				comment={comment}
				value={this.props.value}
				row={this.props.row}
				edit={this.state.edit}
				confirmUncheck={this.state.confirmUncheck}
				mouseMove={this.state.mouseMove}
				onConfirmUncheck={this._handleConfirmUncheck.bind(this)}
				submitting={this.state.submitting}
				td={this.props.td}
				onSelectionChange={this._handleSelectionChange.bind(this)}
				onClosePopup={this._handleClosePopup.bind(this)}
				isServiceAgent={isServiceAgent}
			/>
		)
	}

	_setValue(checked) {
		this.props.onChange("account_theme", {
			account: this.props.row.account,
			chapter: this.props.row.chapter,
			accountIds: this.props.row.accountIds,
			theme: this.props.value.theme,
			checked
		})
		this.setState({edit: false})
	}

	_valueExists() {
		if (this.props.row.account) {
			return this.props.value.amount !== null && this.props.value.amount !== undefined
		} else {
			return this.props.value.theme_has_values
		}
	}

	_handleSelectionChange() {
		var checked = (this.props.value.checked !== "checked") ? true : false

		if (!checked && this._valueExists()) {
			this.setState({confirmUncheck: true})
		} else {
			this._setValue(checked)
		}
	}

	_handleConfirmUncheck() {
		this._setValue(false)
		this.setState({confirmUncheck: false})
	}

	_handleClosePopup() {
		this.setState({confirmUncheck: false})
	}

}

export default AccountThemeEditorContainer



// WEBPACK FOOTER //
// ./src/component/scenarii/admin/account-theme-editor-container.js